<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2">
			<h1 class="h11">巡检工单</h1>
			<div class="clear">
		  		<div class="fl" v-if="administrators!=3 && administrators!=5">
					<el-button @click="showAddCon()"><i class="fa fa-plus"></i> 提交工单 </el-button>
				</div>
		  	</div>
			<br />
			<el-table
		    	stripe
				border
			    ref="multipleTable"
			    :data="deviceList"
			    tooltip-effect="dark"
			    style="width: 100%">
			    <el-table-column
			      type="index"
			      width="30">
			    </el-table-column>
				<el-table-column
			      prop="order"
			      label="工单编号"
				  width="90">
			    </el-table-column>
			    <el-table-column
			      prop="name"
			      label="设备名称">
			    </el-table-column>
				<el-table-column
			      prop="nid"
			      label="资产编号"
				  width="90">
			    </el-table-column>
				<el-table-column
			      prop="title"
			      label="标题">
			    </el-table-column>
				<el-table-column
			      prop="content"
			      label="内容">
			    </el-table-column>
				<el-table-column
			      prop="remarks"
			      label="备注">
			    </el-table-column>
				    
				<el-table-column
					prop="created_time"
					label="创建时间"
					width="90"
					:formatter="dateFormat">
				</el-table-column>
				<!-- <el-table-column
					prop="updated_time"
					label="更新时间"
					width="90"
					:formatter="dateFormat">
				</el-table-column> -->
				<el-table-column
			      prop="state"
			      label="工单状态"
				  width="80"
				  :formatter="formatOrder">
			    </el-table-column>
			    <el-table-column
					width="200px"
		          label="操作">
		          <template slot-scope="scope">
					  <el-button type="text" size="small"
		                       @click="getMsg(scope.$index, scope.row)"> 通知记录
		            </el-button>
					  <el-button type="text" size="small" v-if="scope.row.state !='D' && scope.row.state !='F'"
		                       @click="sendMsg(scope.$index, scope.row)"> 发送通知
		            </el-button>
		            <el-button type="text" size="small"
		                       @click="showModifyDia(scope.$index, scope.row)"> 修改
		            </el-button>
		            <el-button type="danger" size="small"
		                       @click="deleteOrder(scope.$index, scope.row)"> 删除
		            </el-button>
					
		          </template>
		        </el-table-column>
			  </el-table>
			<br />
			<div class="text-right">
				<el-pagination
					@current-change="handleCurrentChange"
				  :page-size="pagesize"
				  layout="total, prev, pager, next"
				  :total="totalNum">
				</el-pagination>
			</div>
		</div>
		<!--删除-->
		<el-dialog title="提示框" :visible.sync="removeFlag" width="500px" >
		    <div class="userInfo">
				<h4>确认删除工单：{{activeOrder.order}} 吗？</h4>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="removeFlag = false">关闭</el-button>
			    <el-button type="primary" @click="confirmRemovUser()">确认</el-button>
			  </div>
		</el-dialog>
		<!--工单通知记录-->
		<el-dialog title="工单通知记录" :visible.sync="msgFlag" width="500px" >
		    <div class="gjym-boxs order-msg" v-if="msgList!=[]">
				<div v-for="(item,index) in msgList" :key="index">
					<p class="text-indent0">{{index+1}}、{{item.type}}:{{item.send}}</p>
					<p class="p6" v-text="dateFormat2(item.time)"></p>
				</div>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="msgFlag = false">关闭</el-button>
			  </div>
		</el-dialog>
		<!--添加工单-->
		<el-dialog title="添加工单" :visible.sync="addFlag" width="500px">
        
	        <el-form :model="manufac" ref="manufac">
	          <el-form-item label="工单编号" :label-width="formLabelWidth">
	            <el-input v-model="manufac.order" placeholder="请输入工单编号" auto-complete="off"></el-input>
	          </el-form-item>
	          <el-form-item label="资产编号" :label-width="formLabelWidth">
	            <el-input v-model="manufac.nid" placeholder="请输入资产编号" auto-complete="off"></el-input>
	          </el-form-item>
	          <el-form-item label="标题" :label-width="formLabelWidth">
	            <el-input v-model="manufac.title" placeholder="请输入标题" auto-complete="off"></el-input>
	          </el-form-item>
	          <el-form-item label="内容" :label-width="formLabelWidth">
	            <el-input v-model="manufac.content" placeholder="请输入内容" auto-complete="off"></el-input>
	          </el-form-item>
			  <el-form-item label="工单状态" v-if="!ifAdd" :label-width="formLabelWidth">
					<el-select class="" v-model="manufac.state" placeholder="请选择">
						<el-option label="新建" value="N"></el-option>
						<el-option label="已完成" value="F"></el-option>
					</el-select>
				</el-form-item>
	          <el-form-item label="备注" :label-width="formLabelWidth">
	            <el-input v-model="manufac.remarks" placeholder="请输入备注" auto-complete="off"></el-input>
	          </el-form-item>
			  
	          
	        </el-form>
	        <div slot="footer" class="dialog-footer">
	          <el-button @click="addFlag=false">取 消</el-button>
	          <el-button type="primary" v-if="ifAdd" @click="confirmAdd()">添 加</el-button>
	          <el-button type="primary" v-if="!ifAdd" @click="modifyManu()">修 改</el-button>
	        </div>
	    </el-dialog>
	    
	    <loading v-if="showLoading"></loading>
	</div>  
</template>

<script>
	export default {
		mounted() {
			this.$nextTick(function(){
				this.getDeviceList();
		  	})
    	},
    	data(){
    		return{
				administrators:this.getCookie("administrators"),
    			deviceList:[],
    			nowPage:1,
    			totalNum:0,
    			pagesize:12,
    			formLabelWidth:'110px',
       			showLoading:false,
       			ifAdd:false,
				activeOrder:{},
				removeFlag:false,
				addFlag:false,
				ifAdd:false,
				manufac:{
					state:null
				},
				msgList:[],
				msgFlag:false
				
       			
    		}
    	},
    	methods:{
    		getDeviceList(){
    			this.showLoading = true;
				let valiCodeParams={
					uid:this.getCookie('uid'),
					company_id:this.getCookie('company_id'),
					page:this.nowPage,
					pagesize:this.pagesize,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/Inspection/list",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.showLoading = false;
		        	if(res.data.code=="200"){
		        		this.deviceList = res.data.data.datalist;
		        		this.totalNum = res.data.data.totalNumber;
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
			//			分页点击事件
			handleCurrentChange(val){
				this.nowPage = val;
				this.getDeviceList();
			},
			deleteOrder(index,row){
				this.activeOrder = row;
				this.removeFlag = true;
			},
			showModifyDia(index,row){
				this.ifAdd = false;
				this.manufac = row;
				this.addFlag = true;
			},
			showAddCon(){
				this.ifAdd = true;
				this.manufac = {
       				state:null
       			};
				this.addFlag = true;
			},
			// 获取工单发送消息记录
			getMsg(index,row){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					id:row.id,				
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/Inspection/sendlogs",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code=="200"){
						this.msgFlag = true;
		        		this.msgList = res.data.data;
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
			// 发送工单通知短信
			sendMsg(index, row){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					id:row.id,
					company_id:this.getCookie('company_id'),					
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/Inspection/send",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code=="200"){
						this.getDeviceList();
		        		this.$message.success(res.data.msg);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
		        	}else{
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
			modifyManu(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					id:this.manufac.id,
					order:this.manufac.order,
					nid:this.manufac.nid,
					title:this.manufac.title,
					content:this.manufac.content,
					remarks:this.manufac.remarks,
					state:this.manufac.state,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/Inspection/rev",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code=="200"){
		        		this.addFlag = false;
		        		this.getDeviceList();
		        		this.$message.success(res.data.msg);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
			confirmAdd(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					order:this.manufac.order,
					nid:this.manufac.nid,
					title:this.manufac.title,
					content:this.manufac.content,
					remarks:this.manufac.remarks,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/Inspection/add",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code=="200"){
		        		this.addFlag = false;
		        		this.getDeviceList();
		        		this.$message.success(res.data.msg);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
			confirmRemovUser(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					id:this.activeOrder.id,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/Inspection/del",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code=="200"){
		        		this.removeFlag = false;
		        		this.getDeviceList();
		        		this.$message.success(res.data.msg);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
			changeStatus(row,status){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					id:row.id,
					mode_enable:status,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/Linkagemanage/revise",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code=="200"){
		        		this.removeFlag = false;
		        		this.getDeviceList();
		        		this.$message.success(res.data.msg);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
			
			
    	}
   }
</script>

<style>
	.search-box2{margin-top: -69px;}
</style>


// WEBPACK FOOTER //
// src/components/rightPanel/repairOrder.vue